// redux/reducers/BannerReducer.js
import {
  FETCH_BANNER_REQUEST,
  FETCH_BANNER_SUCCESS,
  FETCH_BANNER_FAILURE,
} from '../service/bannerService';

const initialState = {
  desk1: {
    loading: false,
    imageUrl: null,
    error: null,
    lastFetched: null,
  },
  mob1: {
    loading: false,
    imageUrl: null,
    error: null,
    lastFetched: null,
  },
};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BANNER_REQUEST:
      return {
        ...state,
        [action.payload.positionID]: {
          ...state[action.payload.positionID],
          loading: true,
          error: null,
        },
      };

    case FETCH_BANNER_SUCCESS:
      return {
        ...state,
        [action.payload.positionID]: {
          loading: false,
          imageUrl: action.payload.imageUrl,
          error: null,
          lastFetched: new Date().toISOString(),
        },
      };

    case FETCH_BANNER_FAILURE:
      return {
        ...state,
        [action.payload.positionID]: {
          ...state[action.payload.positionID],
          loading: false,
          imageUrl: null,
          error: action.payload.error,
          lastFetched: new Date().toISOString(),
        },
      };

    default:
      return state;
  }
};

export default bannerReducer;